<div class="arc-head">
  <div>
    <h3>Recommended for your world</h3>
    <p>{{ subtitle }}</p>
  </div>
  <button type="button" class="arc-link" (click)="whyThese.emit()">Why these? ↗</button>
</div>

<div *ngIf="loading" class="arc-grid">
  <div *ngFor="let _ of [1, 2, 3, 4]" class="arc-card arc-skeleton">
    <div class="arc-art"></div>
    <div class="arc-text"><span class="arc-skel-line arc-skel-short"></span><span class="arc-skel-line"></span></div>
  </div>
</div>

<div *ngIf="!loading && items.length" class="arc-grid">
  <button type="button" *ngFor="let item of items | slice:0:4" class="arc-card" (click)="itemSelected.emit(item)">
    <div class="arc-art">
      <ng-container *ngIf="item.imageUrl">
        <img class="arc-art-backdrop" [src]="item.imageUrl" alt="" aria-hidden="true" loading="lazy" />
        <img class="arc-art-img" [src]="item.imageUrl" alt="" loading="lazy" />
      </ng-container>
      <span class="arc-tag" [style.background]="badgeColor(item)" [style.color]="badgeFontColor(item)">{{ item.badge }}</span>
    </div>
    <div class="arc-text">
      <strong class="arc-title" [title]="item.title">{{ item.title }}</strong>
      <small class="arc-sub" [innerHTML]="item.subtitle"></small>
      <small class="arc-reason" *ngIf="reasons.get(item)">{{ reasons.get(item) }}</small>
    </div>
    <!-- CTA hidden in the redesign; kept for possible reuse.
    <span class="arc-cta" (click)="$event.stopPropagation(); itemSelected.emit(item)">{{ item.ctaLabel }}</span>
    -->
  </button>
</div>

<div *ngIf="!loading && !items.length" class="arc-empty">
  <span class="material-icons">sports_basketball</span>
  <p *ngIf="!hasPreferences">Your personalized recommendations will appear here once your profile is set up.</p>
  <p *ngIf="hasPreferences">No data found for your current preferences. Try updating your selections.</p>
</div>
